import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Form, Input } from 'reactstrap';
import classnames from 'classnames';
import { updateReview } from '../actions/reviewActions';

const ReviewStep3 = ({ reviews, updateReview, nextStep, previousStep }: any) => {
  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    setErrors(reviews.errors);
  }, [reviews.errors]);

  const handleChange = (e) => {
    const field = e.target.name;
    const value = e.target.value;

    if (Object.keys(errors).length > 0) {
      setErrors({});
    }

    updateReview(field, value);
  };

  const handleNext = () => {
    if (reviews.review === '') {
      setErrors({ ...errors, review: 'Required field' });
    } else {
      nextStep();
    }
  };

  return (
    <div className="text-center  parent">
      <div className="px-5  py-3">
        <div>
          <h4 className="font-weight-bold my-3 ">TELL US MORE!</h4>
        </div>

        <div>
          <Form onSubmit={(e) => e.preventDefault()}>
            <Input
              className={classnames('', { 'is-invalid': errors.review })}
              onChange={handleChange}
              type="textarea"
              rows={12}
              name="review"
              value={reviews.review}
              placeholder="Share your experience"
            />
            <div className="invalid-feedback">{errors.review}</div>
          </Form>
        </div>
      </div>

      <div style={{ bottom: 0 }}>
        <div className="float-left">
          <Button outline color="dark" className="border-0" onClick={() => previousStep()}>
            {' '}
            Back{' '}
          </Button>
        </div>
        <div className="float-right">
          <Button outline color="dark" className="border-0" onClick={handleNext}>
            {' '}
            Next{' '}
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  reviews: state.reviews,
});

export default connect(mapStateToProps, { updateReview })(ReviewStep3);
